import { Table as AntdTable, Empty } from 'antd';
import type { TableProps } from 'antd';

import type { HeaderConfig, Pagination } from './Header';
import Header from './Header';

interface Props<RecordType> {
  onChange?: TableProps<RecordType>['onChange'];
  columns: TableProps<RecordType>['columns'];
  dataSource: TableProps<RecordType>['dataSource'];
  rowKey: TableProps<RecordType>['rowKey'];
  summary?: TableProps<RecordType>['summary'];
  onRow?: TableProps<RecordType>['onRow'];
  pagination?: Pagination;
  components?: TableProps<RecordType>['components'];
  headerConfig?: HeaderConfig;
  emptyText?: string;
}

const Table = <RecordType,>({
  onChange,
  columns,
  dataSource,
  rowKey,
  summary,
  pagination,
  onRow,
  components,
  headerConfig,
  emptyText = '',
}: Props<RecordType>) => {
  return (
    <AntdTable
      title={
        headerConfig
          ? () => {
              return <Header {...headerConfig} pagination={pagination} />;
            }
          : undefined
      }
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={emptyText || '검색 결과가 없습니다.'}
          />
        ),
      }}
      scroll={{ x: '100%' }}
      tableLayout="auto"
      showSorterTooltip={false}
      onChange={onChange}
      columns={columns}
      dataSource={dataSource}
      summary={summary}
      rowKey={rowKey}
      onRow={(row, index) => {
        const rowProps = onRow ? onRow(row, index) : {};

        return {
          ...rowProps,
          role: rowProps?.onClick ? 'button' : undefined,
        };
      }}
      components={components}
      pagination={
        pagination
          ? {
              showQuickJumper: false,
              showSizeChanger: false,
              position: ['bottomCenter'],
              current: pagination.query.page,
              pageSize: pagination.query.size,
              total: pagination.total,
              onChange: (page, size) =>
                pagination.setPaginationValues({
                  page,
                  size,
                }),
            }
          : false
      }
    />
  );
};

export default Table;
